import React from 'react';
import classNames from 'classnames';
import InputMask from 'react-input-mask';

import { Icon } from '../Icon/Icon';

interface Props {
  id: string;
  label: string;
  placeholder: string;
  onChange: (value: string) => void;
  value: string;
  className?: string;
  error?: string | boolean;
  showErrorOutLine?: boolean; // Case where we need the ability to show error outline if the input is 1 of 2 inputs
  isReadonly?: boolean;
  mask: string;
  type?: string; // type: 'number' seems to break react-input-mask (I've used instead as we only require numbers for the cases where MaskedInput is used)
}

export const MaskedInput = (props: Props) => {
  const {
    id,
    label,
    onChange,
    value,
    className,
    error,
    placeholder,
    showErrorOutLine,
    isReadonly,
    mask,
    type,
  } = props;

  return (
    <div
      className={classNames('TextInput', className, { hasError: (!!error || showErrorOutLine), isDisabled: isReadonly })}
    >
      <label htmlFor={id}>
        <span className="TextInput-label">{label}</span>

        <InputMask
          mask={mask}
          maskChar=" "
          value={value || ''}
          onChange={(e) => {
            onChange(e.target.value.replace(/[-, _]/g, ''));
          }}
          id={id}
          name={id}
          placeholder={placeholder}
          type={type}
        />

        {/* Error message */}
        {error && (
          <span className="TextInput-error">
            <Icon name="ic-exclamation" />{error}
          </span>
        )}
      </label>
    </div>
  );
};
